var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { normalizeObject, dataLayerPush, toEhashAsync, isChosenProduct, isSponsorshipProduct } from "../shared/utils";
var parseItemData = function (product) {
    var id = product.id, wc_id = product.wc_id, _a = product.uom, uom = _a === void 0 ? "" : _a, price = product.line_total, _b = product.quantity, quantity = _b === void 0 ? 1 : _b;
    var item_brand = isChosenProduct(id) ?
        "chosen" :
        isSponsorshipProduct("".concat(wc_id)) ?
            "sponsorship" :
            "gift_catalog";
    var total_price = quantity > 1 ? parseInt(price) / quantity : parseInt(price);
    var variant = uom === "once" ? "one-time" : uom;
    var item_variant = "".concat(variant, ":").concat(total_price);
    return { item_brand: item_brand, item_variant: item_variant };
};
function mapProducts(products) {
    return products.filter(function (product) {
        //filter out cover the fee in the products array.
        return product.id !== "D10000225";
    }).map(function (product) {
        var item_name = product.name, item_category = product.product_category, item_id = product.id, line_total = product.line_total, _a = product.quantity, quantity = _a === void 0 ? 1 : _a;
        var price = quantity > 1 ? parseInt(line_total) / quantity : parseInt(line_total);
        var _b = parseItemData(product), item_brand = _b.item_brand, item_variant = _b.item_variant;
        return {
            item_brand: item_brand,
            item_category: item_category,
            item_id: item_id,
            item_name: item_name,
            item_variant: item_variant,
            price: price,
            quantity: quantity
        };
    });
}
function checkHasHonorCard(products) {
    var hasHonorCard = products.some(function (_a) {
        var has_honor_card = _a.has_honor_card;
        return !!has_honor_card;
    });
    return hasHonorCard;
}
function checkHasChosenItem(products) {
    var hasChosenItem = products.some(function (_a) {
        var id = _a.id;
        return isChosenProduct(id);
    });
    return hasChosenItem;
}
function getCheckoutType(products, order) {
    var hasChosenItem = checkHasChosenItem(products);
    var hasHonorCard = checkHasHonorCard(products);
    var isDigitalWallet = order.is_digital_wallet ? true : false;
    if (hasChosenItem) {
        return "chosen";
    }
    else if (hasHonorCard) {
        return "ecomm_shipping";
    }
    else if (isDigitalWallet) {
        return "ecomm_express_payment"; // change to ecomm_express_payment
    }
    else {
        return "ecomm";
    }
}
function getCoverTheFeeData(products) {
    var coverTheFeeProduct = products.find(function (_a) {
        var name = _a.name;
        return /cover\s+the\s+fee/i.test(name);
    });
    return coverTheFeeProduct || null;
}
function handleEventData(data) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var order, billingData, products, hasSponsorship, hasChosen, coverTheFee, cart_id, campaign_code, supporter_number, order_ref, checkout_type, payment_method, total_price, ehash, wooOrderId, orderRef, env, transactionId, eventData;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    order = data.order, billingData = data.billingData, products = data.products;
                    hasSponsorship = !!order.new_month_spon || !!order.new_yearly_spon;
                    hasChosen = checkHasChosenItem(products);
                    coverTheFee = getCoverTheFeeData(products);
                    cart_id = order.cart_id;
                    campaign_code = order.campaign_code;
                    supporter_number = billingData.supporter_number;
                    order_ref = ("" + order.order_ref);
                    checkout_type = getCheckoutType(products, order);
                    payment_method = order.payment_method;
                    total_price = parseInt(order.total_price);
                    return [4 /*yield*/, toEhashAsync(billingData.email).catch(function (err) {
                            // TODO: Implement Logger
                            console.log(err);
                            return "";
                        })];
                case 1:
                    ehash = _e.sent();
                    wooOrderId = global && ((_b = (_a = global === null || global === void 0 ? void 0 : global.wvus_order) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b.wc_order_id) || null;
                    orderRef = global && ((_d = (_c = global === null || global === void 0 ? void 0 : global.wvus_order) === null || _c === void 0 ? void 0 : _c.order) === null || _d === void 0 ? void 0 : _d.order_ref) || "prod";
                    env = orderRef.split("-")[1].replace(/\d/g, "");
                    transactionId = "wvus-woo-".concat(env, "-").concat(wooOrderId);
                    eventData = normalizeObject({
                        "event": "purchase",
                        "event_action": "purchase",
                        "event_category": "ecommerce",
                        "event_label": (hasChosen ? "chosen_sponsorship" : (hasSponsorship ? "sponsorship" : "gift_catalog")),
                        "ehash": ehash,
                        "cart_id": cart_id,
                        "supporter_id": supporter_number,
                        "site_transaction_id": transactionId,
                        "site_transaction_status": "pending",
                        "campaign_code": campaign_code,
                        "checkout_type": checkout_type,
                        "cover_fee_amount": coverTheFee && coverTheFee.price || "",
                        "cover_fee_selected": !coverTheFee ? "no_cover_the_fee" : "cover_the_fee",
                        "payment_method_option": payment_method,
                        "non_interaction": true,
                        "ecommerce": {
                            "currency": "USD",
                            "value": total_price,
                            "transaction_id": transactionId,
                            "items": mapProducts(products),
                        }
                    });
                    dataLayerPush(eventData);
                    return [2 /*return*/];
            }
        });
    });
}
var thankYouPurchaseHandler = function (e) {
    var data = e === null || e === void 0 ? void 0 : e.detail;
    handleEventData(data);
};
export { thankYouPurchaseHandler };
